import { gql } from '@apollo/client';

export const REVIEW_FRAGMENT = gql`
  fragment ReviewReturn on Review {
    id
    createdAt
    updatedAt
    order {
      id
    }
    rating
    comment
  }
`;

export const OFFER_FRAGMENT = gql`
  fragment OfferReturn on Offer {
    id
    createdAt
    updatedAt
    order {
      id
    }
    executor {
      id
      createdAt
      updatedAt
      fullName
      category
      heavyTruckType
      driverLicensePhotos
      sorPhotos
      techniqueName
      techniquePhoto
      number
      status
      statusMessage
      workStatus
      completedOrders
      rating
    }
    price
    status
  }
`;

export const ORDER_FRAGMENT = gql`
  ${OFFER_FRAGMENT}
  ${REVIEW_FRAGMENT}
  fragment OrderReturn on Order {
    id
    createdAt
    updatedAt
    user {
      id
      avatar
      name
      phone
    }
    executor {
      id
      createdAt
      updatedAt
      fullName
      category
      heavyTruckType
      driverLicensePhotos
      sorPhotos
      techniqueName
      techniquePhoto
      number
      status
      statusMessage
      workStatus
      completedOrders
      rating
      user {
        phone
      }
    }
    status
    category
    heavyTruckType
    address
    fullAddress
    cityId
    cityName
    longitude
    latitude
    description
    datetime
    loadersCount
    price
    photos
    number
    offers {
      ...OfferReturn
    }
    reviews {
      ...ReviewReturn
    }
  }
`;

export const ADMIN_ORDERS = gql`
  ${ORDER_FRAGMENT}
  query AdminOrders($skip: Int, $take: Int) {
    adminOrders(skip: $skip, take: $take) {
      ...OrderReturn
    }
    adminOrdersCount
  }
`;

export const ADMIN_ORDER = gql`
  ${ORDER_FRAGMENT}
  query AdminOrder($where: UserOrderWhereInput!) {
    adminOrder(where: $where) {
      ...OrderReturn
    }
  }
`;
